import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useCallRecordsListing = ({
  acctId,
  pubPropertyId
}: {
  acctId: string;
  pubPropertyId: string;
}) => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["call-records-list", acctId, pubPropertyId],
    queryFn: async () => {
      const urlKey = t("call-record");
      const response = await axios.get(urlKey, {
        params: {
          acctId,
          pubPropertyId
        }
      });
      return response.data.data;
    },
    refetchOnWindowFocus: false
  });
};
